export default "__VITE_ASSET__CVN2KSwm__"